import axios from '@fs/zion-axios'

export async function downloadImage(fileName, uri) {
  // if the Android FSAndroid interface is available, use it to pass the download uri to the downloadFile method
  // @ts-expect-error - FSAndroid is injected by the mobile app
  if (window?.FSAndroid?.downloadFile) {
    // @ts-expect-error - FSAndroid is injected by the mobile app
    window.FSAndroid.downloadFile(uri, fileName)
    return
  }
  // @ts-expect-error - This is to detect if the page is running in the iOS app
  if (window?.webkit?.messageHandlers?.fsDownloadFile?.postMessage) {
    // @ts-expect-error - This is to detect if the page is running in the iOS app
    window.webkit.messageHandlers.fsDownloadFile.postMessage({
      fileName,
      uri,
    })
    return
  }
  const image = await axios.get(uri, { responseType: 'blob' })
  // If the image is not a png, tiff, or gif, assume it is a jpeg ($dist images are jpeg)
  const imageType = uri.match(/\.(png|tiff?|gif)$/i) ? null : { type: 'image/jpeg' }
  const imageBlob = new Blob([image.data], imageType)
  const imageUrl = window.URL.createObjectURL(imageBlob)
  const a = document.createElement('a')
  a.style.display = 'none'
  a.href = imageUrl
  a.download = fileName
  document.body.appendChild(a)
  a.click()
  window.URL.revokeObjectURL(imageUrl)
}

export function getFileNames(src) {
  let downloadUrl = ''
  let localFileName = ''

  // Regex to parse a file path into components: (path)/(filename without extension).(extension)
  // Groups: [full match, path, full filename, filename without extension, extension]
  const filePathRegex = /(^.*)\/(([\w-.:]+)(\.[\w]+$))/

  if (src.endsWith('.dzi')) {
    const regexArr = src.match(filePathRegex)
    if (regexArr) {
      const [, path, , fileWithoutExtension] = regexArr
      downloadUrl = `${path}/$dist`
      localFileName = `${fileWithoutExtension}.jpg`
    } else {
      throw new Error(`Regex fail, could not extract path and file without extension from ${src}`)
    }
  } else if (src.match(/\.(jpe?g|png|tiff?|gif)$/i)) {
    const regexArr = src.match(filePathRegex)
    if (regexArr) {
      const [, , , fileWithoutExtension, extension] = regexArr
      downloadUrl = src
      localFileName = `${fileWithoutExtension}${extension}`
    } else {
      throw new Error(`Regex fail, could not extract path and file without extension from ${src}`)
    }
  } else {
    const fileNameFull = src.includes('3:1:') ? src.split('3:1:')[1] : ''
    const fileName = fileNameFull.includes('/image.xml') ? fileNameFull.split('/image.xml')[0] : 'image'
    const newSrc = src.split('/image.xml')[0]
    downloadUrl = `${newSrc}/$dist`
    localFileName = `${fileName}.jpg`
  }

  return { downloadUrl, localFileName }
}

export const getOptimizedImageProps = (input, containerWidth) => {
  const { src, forceDeepZoom, srcSet, ...rest } = input
  let finalSrc = src || ''
  let finalForceDeepZoom = forceDeepZoom

  const bestKey = Object.keys(srcSet)
    .map(Number)
    .filter((key) => !Number.isNaN(key) && key <= containerWidth)
    .sort((a, b) => a - b)
    .reverse()[0]
  const bestSrc = input.srcSet[bestKey]

  if (typeof bestSrc === 'string') {
    finalSrc = bestSrc
  } else if (bestSrc) {
    finalSrc = bestSrc.src
    finalForceDeepZoom = bestSrc.forceDeepZoom || finalForceDeepZoom
  }
  return { ...rest, src: finalSrc, forceDeepZoom: finalForceDeepZoom }
}

export default {
  downloadImage,
  getFileNames,
  getOptimizedImageProps,
}
